'use client'

import Error from '@/src/shared/ui/error'

const ErrorPage = ({error, reset}: {error: Error & {digest?: string}; reset?: () => void}) => {
  return (
    <Error status={500} reset={reset} global={true}>
      {(process.env.NODE_ENV === 'development' && error.message) ||
        'Извините, на нашем сайте временно возникли технические неполадки. Мы уже работаем над их устранением! Пожалуйста, попробуйте обновить страницу или вернуться чуть позже. Спасибо за ваше терпение и понимание.'}
    </Error>
  )
}

export default ErrorPage
